export const uploadHairLossPhotosHash = '#hair-loss';
export const uploadLicensePhotoHash = '#license';
export const reviewHairLossPhotosHash = '#review-hair-loss';
export const reviewLicensePhotoHash = '#review-license';
export const photosSuccessfullyUploadedHash = '#photos-successfully-uploaded';
export const trackYourProgressHash = '#track-your-progress';

export const allPossiblePhotoUploadHashes = [
  uploadHairLossPhotosHash,
  uploadLicensePhotoHash,
  reviewHairLossPhotosHash,
  reviewLicensePhotoHash,
  photosSuccessfullyUploadedHash,
  trackYourProgressHash,
];
